export default __webpack_public_path__ + "static/media/AnimatedGif2.81e4bae9.gif";